module.exports = __webpack_public_path__ + "img/uga-athens-covid-vaccine-clinic.b64756ba.jpg";